export enum CheckboxTypesEnum {
    normal,
    button,
    iconBadge,
}
